import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import BinaryMetric from '../BinaryMetric';

export default function FeedbackInternalExternalMetric({
	data,
}: {
	data: graphql.AnalyticsFeedbackInternalExternal;
}) {
	const { t } = useTranslation();

	return (
		<BinaryMetric
			value={data.internal}
			total={data.internal + data.external}
			labels={[
				t('dashboard.metrics.feedbackInternalExternal.internal'),
				t('dashboard.metrics.feedbackInternalExternal.external'),
			]}
		/>
	);
}
